type Props = { size?: number; color?: string };

export function IconYoutube({ size = 16, color = "currentColor" }: Props) {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke={color}
			strokeWidth="1.9"
			strokeLinejoin="round"
			aria-hidden="true"
		>
			<rect x="2" y="5" width="20" height="14" rx="4" />
			<path d="M10 9l6 3-6 3z" fill={color} stroke="none" />
		</svg>
	);
}
